import React, { useEffect, useState } from "react";
import "./report-render.css";
import Axios from "axios";
import constants from "../../constants";

export default function ReportRender() {
  const [paymentSolicitation, setPaymentSolicitation] = useState([]);
  const [totalShipping, setTotalShipping] = useState(0);
  const [totalOrders, setTotalOrders] = useState(0);

  useEffect(() => {
    document.body.style.background = "white";
    document.querySelector("#root").classList.remove("app-header-fixed");

    let data = JSON.parse(localStorage.getItem("request-body"));

    const url =
      constants().URL_SERVICE +
      "establishment/paymentrequest/filter_payment_requests/";

    Axios.post(url, data, {
      headers: { Authorization: "Token " + localStorage.token },
    })
      .then((response) => {
        setPaymentSolicitation(response.data.list);

        let totalOrders = response.data.list.reduce(
          (accum, curr) => accum + curr.price_float,
          0
        );
        setTotalOrders(totalOrders.toFixed(2));

        let totalShipping = response.data.list.reduce(
          (accum, curr) => accum + curr.shipping_float,
          0
        );
        setTotalShipping(totalShipping.toFixed(2));
      })
      .catch((error) => this.setState({ error: true }));
  }, []);

  return (
    <div className="report-main">
      <div className="title">
        <h1>Relatório de Solicitação de Pagamento</h1>
      </div>

      {paymentSolicitation.length > 0 && (
        <div className="container-header">
          <div className="header-left">
            <table className="table">
              <tbody>
                <tr>
                  <td>
                    <span className="header-item-bold">Empresa: </span>
                    {paymentSolicitation[0].establishment.name}
                  </td>
                  <td>
                    <span className="header-item-bold">Rua: </span>
                    {paymentSolicitation[0].establishment.street}
                  </td>
                  <td>
                    <span className="header-item-bold">Número: </span>
                    {paymentSolicitation[0].establishment.number}
                  </td>
                  <td>
                    <span className="header-item-bold">Estado: </span>
                    {paymentSolicitation[0].establishment.state}
                  </td>
                </tr>
                <tr>
                  <td>
                    <span className="header-item-bold">CEP: </span>
                    {paymentSolicitation[0].establishment.postal_code}
                  </td>
                  <td>
                    <span className="header-item-bold">Contato gerente: </span>
                    {paymentSolicitation[0].establishment.manager_contact}
                  </td>
                  {/* <td>
                    <span className="header-item-bold">Estado: </span>
                    {paymentSolicitation[0].establishment.state}
                  </td>
                  <td>
                    <span className="header-item-bold">Estado: </span>
                    {paymentSolicitation[0].establishment.state}
                  </td> */}
                </tr>
              </tbody>
            </table>
          </div>
          <div className="header-right">
            <table className="table">
              <tbody>
                {/* {paymentSolicitation.map((solicition, i) => ( */}
                <tr>
                  <td>
                    {JSON.parse(localStorage.getItem("request-body")).date}
                  </td>
                  <td>
                    {JSON.parse(localStorage.getItem("request-body")).time}
                  </td>
                </tr>
                <tr>
                  <td>
                    <span className="header-item-bold">Data inicio: </span>
                    {
                      JSON.parse(localStorage.getItem("request-body"))
                        .displayDate.startDate
                    }
                  </td>
                  <td>
                    <span className="header-item-bold">Data fim: </span>
                    {
                      JSON.parse(localStorage.getItem("request-body"))
                        .displayDate.endDate
                    }
                  </td>
                </tr>
                {/* ))} */}
              </tbody>
            </table>
          </div>
        </div>
      )}
      <h4>Solicitações</h4>
      <div className="table-wrap" style={{ "font-size": "9px" }}>
        <table className="table table-striped">
          <thead>
            <tr>
              <th>Seq</th>
              <th>Id</th>
              <th>Cliente</th>
              <th>E-mail</th>
              <th>Data</th>
              <th>Status</th>
              <th>Valor Frete</th>
              <th>Valor Pedido</th>
            </tr>
          </thead>
          <tbody>
            {paymentSolicitation.map((solicition, i) => (
              <tr>
                <td>{i + 1}</td>
                <td>{solicition.id}</td>
                <td>
                  {solicition.client.first_name} {solicition.client.last_name}
                </td>
                <td>{solicition.client.email}</td>
                <td>
                  {solicition.date} - {solicition.time}
                </td>
                <td>{solicition.status_title}</td>
                <td>{solicition.shipping}</td>
                <td>{solicition.price}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <div style={{ textAlign: "-webkit-right", padding: "30px 0px 10px 0px" }}>
          <table className="table-wrap" style={{ width: "248px" }} border="1">
            <tbody>
              <tr>
                <td style={{ width: "63.5312px" }}>&nbsp;Subtotal</td>
                <td style={{ width: "179.469px" }}>
                  <table style={{ width: "182px" }} border="1">
                    <tbody className="table-wrap">
                      <tr>
                        <td style={{ width: "91.4062px", "text-align": "end" }}>
                          R${String(totalShipping).replace(".", ",")}
                        </td>
                        <td style={{ width: "88.5938px", "text-align": "end" }}>
                          R${String(totalOrders).replace(".", ",")}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              <tr>
                <td style={{ width: "63.5312px" }}>&nbsp;Total</td>
                <td style={{ width: "179.469px", "text-align": "end" }}>
                  R$
                  {String(
                    parseFloat(totalOrders) + parseFloat(totalShipping)
                  ).replace(".", ",")}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/views/Reports/report-render.js